module.exports = __webpack_public_path__ + "img/FI18175079.36274592.png";